export const COOKIEBOT_DOMAIN_GROUP_ID = '13211f9c-d687-46f5-af3c-6add0081cb60';
export const RECAPTCHA_KEY = '6LdpJ6MhAAAAAOiiazcQTQNdn5humGOzI6mVDMRW';
